import type { QueryClient } from '@tanstack/react-query';
import type { AnalyticsMode } from '~/views/Dashboard/AnalyticsStats/analyticsMode';

/**
 * Invalidate discovery/views for an account in both client and authoring modes.
 * Prefix stops before the authoring stat-set segment so pre-seed keys (`v2` /
 * `v2_legacy`) and live keys (`null`) all match.
 */
export function invalidateClientAnalyticsQueries(
  queryClient: QueryClient,
  accountId: number,
  accountType: 'client' | 'partner',
) {
  for (const mode of ['client', 'authoring'] as const satisfies readonly AnalyticsMode[]) {
    queryClient.invalidateQueries({
      queryKey: ['analytics-stats', 'views', accountId, accountType, mode],
    });
    queryClient.invalidateQueries({
      queryKey: ['analytics-stats', 'list', accountId, accountType, mode],
    });
  }
}
